import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';
import { middleware as thunkMiddleware } from 'redux-saga-thunk';
import LogRocket from 'logrocket';

import rootReducer from '../slices';
import rootSaga from '../sagas';
import websocketMiddleware from '../middleware/websocket';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [thunkMiddleware, sagaMiddleware, websocketMiddleware];

if (import.meta.env.PROD && import.meta.env.VITE_LOGROCKET) {
  middlewares.push(LogRocket.reduxMiddleware());
}

const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
  reducer: rootReducer,
});

sagaMiddleware.run(rootSaga);

export default store;
